import { render, staticRenderFns } from "./table-task-info.vue?vue&type=template&id=67b1f1ac&"
import script from "./table-task-info.vue?vue&type=script&lang=js&"
export * from "./table-task-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports